export default "__VITE_ASSET__Ba4qY$zC__"